<template>
    <div v-if="pages > 1" class="text-center">
        <v-pagination
            v-model="page"
            :length="pages"
            :disabled="pages === 0"
            total-visible="7"
            color="primary"
            @update:model-value="change"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue, Setup} from 'vue-facing-decorator'
    import {useGoTo} from 'vuetify'

    @Component
    export class Pagination extends Vue {
        @VModel() page
        @Prop() pages
        @Setup(() => useGoTo()) goTo

        change() {
            this.goTo(0)
        }
    }

    export default Pagination
</script>

<style scoped></style>
